var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "user-page" } },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "col-5" }, [
          _c("h5", [_vm._v("メディア一覧")]),
          _c("h5", [
            _vm._v("フォルダ名：" + _vm._s(_vm.folderInfo.folderName)),
          ]),
        ]),
        _c("div", { staticClass: "col-5" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info",
              attrs: { id: "backBtn", type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("戻る")]
          ),
          _vm.isAdmin && _vm.folderInfo.isPrivate && _vm.message
            ? _c(
                "button",
                {
                  staticClass: "btn-sm btn-outline-danger btn_right",
                  attrs: { id: "destroyBtn", type: "button" },
                  on: { click: _vm.destroy },
                },
                [_vm._v("個人フォルダを削除")]
              )
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "main" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-10" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.processedPhotos, function (photo) {
              return _c(
                "div",
                { key: photo.index, staticClass: "col-3 photo" },
                [
                  photo.type == "audio"
                    ? _c("div", [
                        _c("div", { staticClass: "card card-height" }, [
                          _c(
                            "div",
                            { staticClass: "card-img parent-position" },
                            [
                              photo.mediaPlayUrl
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "event-controller",
                                      on: {
                                        click: function ($event) {
                                          return _vm.startMediaStream(
                                            photo.mediaPlayUrl,
                                            photo.type
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "thumbnail-overlay",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 100 100",
                                            height: "100%",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            staticStyle: { fill: "#00C3E0" },
                                            attrs: {
                                              d: "M12,3v9.28c-0.47,-0.17 -0.97,-0.28 -1.5,-0.28C8.01,12 6,14.01 6,16.5S8.01,21 10.5,21c2.31,0 4.2,-1.75 4.45,-4H15V6h4V3h-7z",
                                              transform: "translate(38, 38)",
                                            },
                                          }),
                                          _c("path", {
                                            staticStyle: {
                                              fill: "#000",
                                              opacity: "0.5",
                                            },
                                            attrs: {
                                              d: "M8,5v14l11,-7z",
                                              transform: "translate(38, 38)",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v("投稿者：" + _vm._s(photo.user.userName)),
                          ]),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v(
                              "投稿日：" + _vm._s(_vm.moment(photo.createdAt))
                            ),
                          ]),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v("期 限：" + _vm._s(photo.deletedAt)),
                          ]),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "btn-sm btn-light dl-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadAudio(
                                  photo.blobUrl,
                                  photo.mediaPath
                                )
                              },
                            },
                          },
                          [_vm._v("ダウンロードする")]
                        ),
                      ])
                    : photo.type == "video"
                    ? _c("div", [
                        _c("div", { staticClass: "card card-height" }, [
                          _c(
                            "div",
                            { staticClass: "card-img parent-position" },
                            [
                              photo.mediaPlayUrl
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "event-controller",
                                      on: {
                                        click: function ($event) {
                                          return _vm.startMediaStream(
                                            photo.mediaPlayUrl,
                                            photo.type
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "card-img-thumbnail",
                                        attrs: { src: photo.thumbnailBlobUrl },
                                      }),
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "thumbnail-overlay",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 100 100",
                                            height: "100%",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            staticStyle: {
                                              fill: "#000",
                                              opacity: "0.5",
                                            },
                                            attrs: {
                                              d: "M8,5v14l11,-7z",
                                              transform: "translate(38, 38)",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v("投稿者：" + _vm._s(photo.user.userName)),
                          ]),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v(
                              "投稿日：" + _vm._s(_vm.moment(photo.createdAt))
                            ),
                          ]),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v("期 限：" + _vm._s(photo.deletedAt)),
                          ]),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "btn-sm btn-light dl-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadVideo(
                                  photo.blobUrl,
                                  photo.mediaPath
                                )
                              },
                            },
                          },
                          [_vm._v("ダウンロードする")]
                        ),
                      ])
                    : _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "card card-height",
                            attrs: {
                              href: photo.blobUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "card-img",
                              attrs: { src: photo.blobUrl },
                            }),
                            _c("p", { staticClass: "card-text" }, [
                              _vm._v("投稿者：" + _vm._s(photo.user.userName)),
                            ]),
                            _c("p", { staticClass: "card-text" }, [
                              _vm._v(
                                "投稿日：" + _vm._s(_vm.moment(photo.createdAt))
                              ),
                            ]),
                            _c("p", { staticClass: "card-text" }, [
                              _vm._v("期 限：" + _vm._s(photo.deletedAt)),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn-sm btn-light dl-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.download(
                                  photo.blobUrl,
                                  photo.imagePath
                                )
                              },
                            },
                          },
                          [_vm._v("ダウンロードする")]
                        ),
                      ]),
                ]
              )
            }),
            0
          ),
          _c("nav", { attrs: { "aria-label": "pager" } }, [
            _c("ul", { staticClass: "pagination justify-content-center" }, [
              _vm.isPrev
                ? _c("li", [
                    _vm.navigationButtonsEnabled
                      ? _c(
                          "a",
                          {
                            staticClass: "btn page-link rounded-pill",
                            on: { click: _vm.goPrev },
                          },
                          [_vm._v("← 前")]
                        )
                      : _c("p", { staticClass: "btn page-link rounded-pill" }, [
                          _vm._v("← 前"),
                        ]),
                  ])
                : _vm._e(),
              _vm.isPrev || _vm.isNext
                ? _c("li", { staticClass: "mx-2" }, [
                    _c("a", { staticClass: "btn page-link rounded-pill" }, [
                      _vm._v("現在"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isNext
                ? _c("li", [
                    _vm.navigationButtonsEnabled
                      ? _c(
                          "a",
                          {
                            staticClass: "btn page-link rounded-pill",
                            on: { click: _vm.goNext },
                          },
                          [_vm._v("次 →")]
                        )
                      : _c("p", { staticClass: "btn page-link rounded-pill" }, [
                          _vm._v("次 →"),
                        ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-3" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }